<fav-tournaments></fav-tournaments>

<div class="container">
  <div class="header single">
    <div class="header-row">
      <div class="header-text left-menu-text">
        {{ 'quick_links' | translate }}
      </div>
    </div>
  </div>
  <div class="content">
    <div class="item" routerLink="/favorites" *ngIf="this._UserHelper.isSignedIn && this._DataHelper.favList.length > 0">
      <div class="left">
        <div class="league">
          <image-loader-utils [url]="'favorited'" [isFlags]="true" extraClasses="favorited-left-menu" imageFormat="png"></image-loader-utils>
        </div>
      </div>
      <div class="mid">{{ 'Favorites' | translate }}</div>
    </div>
    <div class="item" routerLink="/home">
      <div class="left">
        <div class="league">
          <image-loader-utils [url]="'top-events'" [isFlags]="true" extraClasses="favorited-left-menu" imageFormat="png"></image-loader-utils>
        </div>
      </div>
      <!-- <div class="mid">{{ 'Top_Events' | translate  }}</div> -->
      <div class="mid">Top-Events</div>
    </div>
  </div>
</div>
<div
  class="container promotion-container"
  *ngIf="environment.isPromotion && !isNaN(this._PromotionService.promotionCount) && this._PromotionService.promotionCount > 0"
  routerLink="/promotions">
  <div class="header single">
    <div class="header-row">
      <image-loader-utils url="promotion" extraClasses="promotion-icon"></image-loader-utils>
      <div class="promotion-text">{{ 'PROMOTIONS_BUTTON' | translate }}</div>
      <div class="promotion-count">
        <div class="promotion-count-text">{{ this._PromotionService.promotionCount }}</div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="header single">
    <div class="header-row">
      <div class="header-text left-menu-text">
        {{ 'Top_Leagues' | translate }}
      </div>
    </div>
  </div>
  <div class="content" *ngIf="isOpenLeagueMenu">
    <top-leagues></top-leagues>
  </div>
</div>
<div class="container">
  <div class="header border">
    <div class="header-row">
      <div class="header-text left-menu-text">
        {{ 'Sports' | translate }}
      </div>
    </div>
  </div>
  <div class="header">
    <div class="time-container">
      <div class="time-container-box" [ngClass]="{ active: this._dayFilter == 300 }" (click)="timeFilterChangedDesktop(300)">{{ 'All' | translate }}</div>
      <div class="time-container-box" [ngClass]="{ active: this._dayFilter == 1 }" (click)="timeFilterChangedDesktop(1)">{{ 'FilterDay1Hour_Short' | translate }}</div>
      <div class="time-container-box" [ngClass]="{ active: this._dayFilter == 12 }" (click)="timeFilterChangedDesktop(12)">{{ 'FilterDay12Hour_Short' | translate }}</div>
      <div class="time-container-box" [ngClass]="{ active: this._dayFilter == 24 }" (click)="timeFilterChangedDesktop(24)">{{ 'FilterDay1Day_Short' | translate }}</div>
    </div>
  </div>
  <div class="content" *ngIf="isOpenSportsMenu">
    <ng-container *ngIf="mainData == undefined || mainData?.length < 1">
      <ngx-skeleton-loader [theme]="{ height: '19px', width: '220px', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
    </ng-container>

    <ng-container *ngFor="let item of mainData; let i = index">
      <div class="sports-menu-item sport-active">
        <div class="item-row" (click)="getCountriesBySportsID(item.SportId, i)">
          <div class="left">
            <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="sportmenusvg" [imageFormat]="'png'"></image-loader-utils>
          </div>
          <div class="mid">{{ item.SportName }}</div>
          <div class="right"></div>
        </div>
        <div class="item-box" *ngIf="item.state">
          <ng-container *ngFor="let item2 of mainData[i].level; let k = index">
            <div class="sports-menu-dropdown">
              <div class="sports-menu-item row country" (click)="openAll(mainData[i].level[k], item2, item, i, k)">
                <div class="left">
                  <image-loader-flag-utils [url]="item2.IsoName" [isFlags]="true" extraClasses="flag-rounded" imageFormat="png"></image-loader-flag-utils>
                </div>
                <div class="mid">{{ item2.CategoryName }}</div>
              </div>
            </div>
            <div class="item-box2" *ngIf="item2.state">
              <ng-container *ngFor="let item3 of mainData[i].level[k].level; let l = index">
                <div class="menu-content-item">
                  <league-utils [extraClass]="'left-menu-desktop'" [leagueId]="item3.BetradarId"></league-utils>

                  <div class="mid" (click)="openLeague(item, item3, item2)">{{ item3.TournamentName }}</div>
                  <div class="right">
                    <div class="event-count">
                      {{ item3.TournamentSportEventCount }}
                    </div>
                    <div (click)="add2TournamentFavs(item3, item2)">
                      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngFor="let item3 of mainData[i].level[k].outrights; let l = index">
                <div class="menu-content-item">
                  <div class="mid" [routerLink]="['/outright/' + item3.TournamentId]">{{ item3.TournamentName }} {{ 'SeasonBets' | translate }}</div>
                  <div class="right">
                    <div class="event-count">
                      {{ item3.TournamentSportEventCount }}
                    </div>
                    <div (click)="add2TournamentFavs(item3, item2)">
                      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- <div class="desktop-left-menu-button-color btn white btn-h-30" (click)="openStats('statistics')">
  <div class="btn-text">
    {{ 'Results' | translate }}
  </div>
</div>
<div class="desktop-left-menu-button-color btn white mt-8 btn-h-30" (click)="openStats('livescore')">
  <div class="btn-text">
    {{ 'statistics' | translate }}
  </div>
</div> -->
